import React, { useContext } from 'react';

import styled from 'styled-components';
import { Button, Card } from 'components';
import { LayoutContext } from 'contexts';
import AppointmentDeskContext, {
  AppointmentDeskStep,
} from '../AppointmentDeskContext';
import ListingTable from './ListingTable';
import ManageListingsContext from './ManageListingsContext';
import EnableToggleCard from './EnableToggleCard';

import { TOGGLE_CARD_HEIGHT } from '../constants';
import DefaultToggleCard from './DefaultToggleCard';

const ManageListingsLayout: React.FC = () => {
  const { getSiderCurrentWidth } = useContext(LayoutContext);
  const { currentStep, setCurrentStep } = useContext(AppointmentDeskContext);
  const { containerRef, footerRef } = useContext(ManageListingsContext);

  return (
    <>
      <StyledManageListingsContainer ref={containerRef}>
        <EnableToggleCard />
        <DefaultToggleCard />
        <StyledListingsTableContainer
          $marginBottom={footerRef.current ? 42 : 0}
          data-cy="listing-table-container"
        >
          <ListingTable />
        </StyledListingsTableContainer>
      </StyledManageListingsContainer>
      {currentStep === AppointmentDeskStep.ManageListings && (
        <StyledFooter $left={getSiderCurrentWidth()} ref={footerRef}>
          <Button
            type="primary"
            size="large"
            onClick={() => setCurrentStep(AppointmentDeskStep.Activate)}
            data-cy="listings-continue-button"
          >
            Continue
          </Button>
        </StyledFooter>
      )}
    </>
  );
};

export default ManageListingsLayout;

const StyledManageListingsContainer = styled.div`
  min-width: 924px;
  display: grid;
  grid-template: ${TOGGLE_CARD_HEIGHT - 5}px / 1fr 1fr;
  width: 100%;
  gap: 5px;
`;

const StyledListingsTableContainer = styled(Card)<{ $marginBottom?: number }>`
  grid-area: span 1 / span 2;
  .ant-card-body {
    padding: 0;
  }
  ${({ $marginBottom }) =>
    $marginBottom && `margin-bottom: ${$marginBottom}px`};
`;

const StyledFooter = styled.div<{ $left: number }>`
  border: 1px solid #f0f0f0;
  background-color: white;
  display: flex;
  justify-content: right;
  align-items: center;
  position: sticky;
  bottom: 0;
  height: 67px;
  min-width: 924px;
  width: 100%;
  padding-right: 43px;
  ${Button} {
    width: 185px;
    border-radius: 2px;
  }
`;
